import type { ContactFieldType } from "../helpers/audience_helper";

/**
 * Packs sugeridos por vertical (ICP Starter sem loja — DOC 04 § 1.1).
 * Por quê: Carla aplica campos tipados sem inventar slug; usa o CRUD existente.
 */
export type SuggestedContactField = {
  labelKey: string;
  slug: string;
  type: ContactFieldType;
  is_filterable: boolean;
};

export type SuggestedContactFieldPackId = "educacao" | "saas" | "publisher";

export type SuggestedContactFieldPack = {
  id: SuggestedContactFieldPackId;
  titleKey: string;
  descriptionKey: string;
  fields: SuggestedContactField[];
};

/** Tags de galeria que têm pack de campos correspondente. */
export function packIdFromGalleryTag(
  tag: string | null | undefined
): SuggestedContactFieldPackId | null {
  if (tag === "educacao" || tag === "saas" || tag === "publisher") {
    return tag;
  }
  return null;
}

export function packById(
  id: string | null | undefined
): SuggestedContactFieldPack | undefined {
  return SUGGESTED_CONTACT_FIELD_PACKS.find((p) => p.id === id);
}

export const SUGGESTED_CONTACT_FIELD_PACKS: SuggestedContactFieldPack[] = [
  {
    id: "educacao",
    titleKey: "contactFields.packs.educacao.title",
    descriptionKey: "contactFields.packs.educacao.description",
    fields: [
      {
        labelKey: "contactFields.packs.educacao.curso",
        slug: "curso",
        type: "text",
        is_filterable: true,
      },
      {
        labelKey: "contactFields.packs.educacao.turma",
        slug: "turma",
        type: "text",
        is_filterable: true,
      },
    ],
  },
  {
    id: "saas",
    titleKey: "contactFields.packs.saas.title",
    descriptionKey: "contactFields.packs.saas.description",
    fields: [
      {
        labelKey: "contactFields.packs.saas.empresa",
        slug: "empresa",
        type: "text",
        is_filterable: true,
      },
      {
        labelKey: "contactFields.packs.saas.plano",
        slug: "plano",
        type: "text",
        is_filterable: true,
      },
    ],
  },
  {
    id: "publisher",
    titleKey: "contactFields.packs.publisher.title",
    descriptionKey: "contactFields.packs.publisher.description",
    fields: [
      {
        labelKey: "contactFields.packs.publisher.interesse",
        slug: "interesse",
        type: "text",
        is_filterable: true,
      },
      {
        labelKey: "contactFields.packs.publisher.fonte",
        slug: "fonte",
        type: "text",
        is_filterable: true,
      },
    ],
  },
];
